import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, signal, WritableSignal } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { arePropertiesDifferentVersion2 } from '@phoenix/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BlockableDiv } from '../../../../shared/controls/blockable-div/blockable-div.component';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { Product } from '../../../../generated/generated-types';
import { FormlyFillHeightListHostDirective } from '../../../custom-formly/formly-tabs/formly-fill-height-list-host.directive';
import { AccessoryConfigProductLinkListWidgetComponent } from '../accessory-config-product-link-list-widget/accessory-config-product-link-list-widget.component';

@Component({
  selector: 'app-formly-accessory-config-product-widget',
  templateUrl: './formly-accessory-config-product-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [FormlyFillHeightListHostDirective],
  standalone: true,
  imports: [
    AccessoryConfigProductLinkListWidgetComponent,
    BlockableDiv,
    TranslatePipe,
    ButtonModule,
    TooltipModule,
  ]
})
export class FormlyAccessoryConfigProductWidgetComponent extends FieldType<FieldTypeConfig> {

  private readonly cdRef = inject(ChangeDetectorRef);

  productSig: WritableSignal<Product> = signal(null);
  isSaving = signal(false);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.productSig.set(this.form.value);

    this.form.valueChanges.subscribe((product: Product) => {
      const diff = arePropertiesDifferentVersion2(this.productSig(), product);
      if (diff.isDifferent) {
        this.productSig.set(product);
      }
    });
  }

  checkIfCanSave(): boolean {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Product>;
    return component.detailForm.invalid;
  }

  async saveToUnlockEditMode(): Promise<void> {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Product>;
    if (!component) {
      console.error('No detail component found to save Product');
      return;
    }

    this.isSaving.set(true);
    this.cdRef.detectChanges();

    await component.save();

    this.isSaving.set(false);
    this.cdRef.detectChanges();
  }

}
